import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { Tabs, Tab, Card, Box, CardContent } from '@mui/material'
import DeliveryOrder from './DeliveryOrder'
import DeliveryNote from './DeliveryNote'
import PropTypes from 'prop-types'

const OrderDetail = ({ data: order }) => {
  const { t } = useTranslation('order_detail')
  const [selectedTab, setSelectedTab] = useState(0)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Tabs value={selectedTab} onChange={handleTabChange} aria-label="order detail tabs">
            <Tab label={t('deliveryOrders')} />
            <Tab label={t('deliveryNotes')} />
          </Tabs>
        </Box>
        <TabPanel value={selectedTab} index={0}>
        <Box>
            <DeliveryOrder orderId={order.id} />
          </Box>
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <Box>
            <DeliveryNote orderId={order.id} />
          </Box>
        </TabPanel>
      </CardContent>
    </Card>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}
OrderDetail.propTypes = {
  data: PropTypes.object.isRequired,
}
TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
}

export default OrderDetail